import { render, staticRenderFns } from "./ApeTable.vue?vue&type=template&id=4cd4a4fe&scoped=true&"
import script from "./ApeTable.vue?vue&type=script&lang=js&"
export * from "./ApeTable.vue?vue&type=script&lang=js&"
import style0 from "./ApeTable.vue?vue&type=style&index=0&id=4cd4a4fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4a4fe",
  null
  
)

export default component.exports